import { render, staticRenderFns } from "./Jindex.vue?vue&type=template&id=73026201&scoped=true"
import script from "./Jindex.vue?vue&type=script&lang=js"
export * from "./Jindex.vue?vue&type=script&lang=js"
import style0 from "./Jindex.vue?vue&type=style&index=0&id=73026201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73026201",
  null
  
)

export default component.exports